/**
 * You need to upload the images to the s3 to make it work
 * 3 versions: origin, 400x225, 1280x720
 * Last update: https://ahaslides.atlassian.net/browse/AHA-31325
 * S3 bucket:
 *    dev - static.ahaslide.com/themes/
 *   prod - static.ahaslides.com/themes/
 */

const thumbnailDay = require('@/assets/images/themes/Day-text.jpg')
const canvasDay = require('@/assets/images/themes/1280x720-Day.jpg')

const thumbnailDusk = require('@/assets/images/themes/Dusk-text.jpg')
const canvasDusk = require('@/assets/images/themes/1280x720-Dusk.jpg')

const thumbnailNight = require('@/assets/images/themes/Night-text.jpg')
const canvasNight = require('@/assets/images/themes/1280x720-Night.jpg')

const thumbnailScience = require('@/assets/images/themes/science-thumbnail-26022025.png')
const canvasScience = require('@/assets/images/themes/science-26022025.png')

const thumbnailClassroom = require('@/assets/images/themes/classroom-thumbnail-03012025.png')
const canvasClassroom = require('@/assets/images/themes/classroom-03012025.jpg')

const thumbnailCalm = require('@/assets/images/themes/calm-thumbnail-03012025.png')
const canvasCalm = require('@/assets/images/themes/calm-03012025.jpg')

const thumbnailMeeting = require('@/assets/images/themes/meeting-thumbnail-26022025.png')
const canvasMeeting = require('@/assets/images/themes/meeting-26022025.png')

const thumbnailParty = require('@/assets/images/themes/Party-thumb-241204.png')
const canvasParty = require('@/assets/images/themes/Party-241204.png')

const thumbnailHarmony = require('@/assets/images/themes/harmony-thumbnail-03012025.jpg')
const canvasHarmony = require('@/assets/images/themes/harmony-03012025.jpg')

const thumbnailAbstract = require('@/assets/images/themes/abstract-thumbnail-03012025.jpg')
const canvasAbstract = require('@/assets/images/themes/abstract-03012025.jpg')

const thumbnailGeometric = require('@/assets/images/themes/geometric-thumbnail-03012025.jpg')
const canvasGeometric = require('@/assets/images/themes/geometric-03012025.jpg')

const thumbnailBusiness = require('@/assets/images/themes/business-thumbnail-03012025.jpg')
const canvasBusiness = require('@/assets/images/themes/business-03012025.jpg')

export const DEFAULT_THEME_ATTRIBUTES = {
  textColour: '#313131',
  baseColour: '#ffffff',
  backgroundImage: null,
  visibility: 20,
}

export default {
  presentations: [
    {
      themeName: 'Day',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 100,
      backgroundImage: {
        thumbnail: canvasDay,
        large: canvasDay,
        xLarge: canvasDay,
        name: 'themes/Day.jpg',
      },
      themeThumbnail: thumbnailDay,
      themeId: 1,
    },
    {
      themeName: 'Dusk',
      textColour: '#ffffff',
      baseColour: '#313131',
      visibility: 65,
      backgroundImage: {
        thumbnail: canvasDusk,
        large: canvasDusk,
        xLarge: canvasDusk,
        name: 'themes/Dusk.jpg',
      },
      themeThumbnail: thumbnailDusk,
      themeId: 2,
    },
    {
      themeName: 'Night',
      textColour: '#ffffff',
      baseColour: '#000000',
      visibility: 100,
      backgroundImage: {
        thumbnail: canvasNight,
        large: canvasNight,
        xLarge: canvasNight,
        name: 'themes/Night.jpg',
      },
      themeThumbnail: thumbnailNight,
      themeId: 3,
    },

    {
      themeName: 'Meeting',
      textColour: '#ffffff',
      baseColour: '#212a4c',
      visibility: 87,
      backgroundImage: {
        thumbnail: canvasMeeting,
        large: canvasMeeting,
        xLarge: canvasMeeting,
        name: 'themes/meeting-26022025.jpg',
      },
      themeThumbnail: thumbnailMeeting,
      themeId: 4,
    },
    {
      themeName: 'Classroom',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasClassroom,
        large: canvasClassroom,
        xLarge: canvasClassroom,
        name: 'themes/classroom-03012025.jpg',
      },
      themeThumbnail: thumbnailClassroom,
      themeId: 5,
    },
    {
      themeName: 'Calm',
      textColour: '#ffffff',
      baseColour: '#313131',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasCalm,
        large: canvasCalm,
        xLarge: canvasCalm,
        name: 'themes/calm-03012025.jpg',
      },
      themeThumbnail: thumbnailCalm,
      themeId: 6,
    },
    {
      themeName: 'Science',
      textColour: '#313131',
      baseColour: '#c9e6fd',
      visibility: 87,
      backgroundImage: {
        thumbnail: canvasScience,
        large: canvasScience,
        xLarge: canvasScience,
        name: 'themes/science-26022025.jpg',
      },
      themeThumbnail: thumbnailScience,
      themeId: 7,
    },
    {
      themeName: 'Party',
      textColour: '#ffffff',
      baseColour: '#313131',
      visibility: 90,
      backgroundImage: {
        thumbnail: canvasParty,
        large: canvasParty,
        xLarge: canvasParty,
        name: 'themes/Party-241204.png',
      },
      themeThumbnail: thumbnailParty,
      themeId: 8,
    },
    {
      themeName: 'Harmony',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 100,
      backgroundImage: {
        thumbnail: canvasHarmony,
        large: canvasHarmony,
        xLarge: canvasHarmony,
        name: 'themes/harmony-03012025.jpg',
      },
      themeThumbnail: thumbnailHarmony,
      themeId: 9,
    },
    {
      themeName: 'Abstract',
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 100,
      backgroundImage: {
        thumbnail: canvasAbstract,
        large: canvasAbstract,
        xLarge: canvasAbstract,
        name: 'themes/abstract-03012025.jpg',
      },
      themeThumbnail: thumbnailAbstract,
      themeId: 10,
    },
    {
      themeName: 'Geometric',
      textColour: '#ffffff',
      baseColour: '#313131',
      visibility: 80,
      backgroundImage: {
        thumbnail: canvasGeometric,
        large: canvasGeometric,
        xLarge: canvasGeometric,
        name: 'themes/geometric-03012025.jpg',
      },
      themeThumbnail: thumbnailGeometric,
      themeId: 11,
    },
    {
      themeName: 'Business',
      textColour: '#ffffff',
      baseColour: '#313131',
      visibility: 80,
      backgroundImage: {
        thumbnail: canvasBusiness,
        large: canvasBusiness,
        xLarge: canvasBusiness,
        name: 'themes/business-03012025.jpg',
      },
      themeThumbnail: thumbnailBusiness,
      themeId: 12,
    },
  ],
}
